function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.46 2.922a.8.8 0 01.994 1 7.828 7.828 0 009.621 9.624.798.798 0 011.007.549.8.8 0 01-.004.447A9.427 9.427 0 119.46 2.922zm-.826 2.012a7.826 7.826 0 1010.432 10.432A9.427 9.427 0 018.634 4.934z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgMoon;